import { render, staticRenderFns } from "./ProductoForm.vue?vue&type=template&id=3b69c34c&"
import script from "./ProductoForm.vue?vue&type=script&lang=js&"
export * from "./ProductoForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports